<div>
  <div *ngIf="false" id="header-box">
    <app-header></app-header>
  </div>
  <div id="menu-box">
    <app-menu></app-menu>
  </div>
  <div id="router-outlet">
    <router-outlet></router-outlet>
  </div>
  <div *ngIf="false" id="footer-box">
    <app-footer></app-footer>
  </div>
  <app-chat-widget></app-chat-widget>
</div>
